// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import * as Yup from 'yup';

// import { AppError } from '../../errors/AppError';

// import api from '../../services/api';
// import history from '../../services/history';

// import {
//   opTipoAcao,
//   opTipoDocumento,
//   opMascaraDocumento,
// } from '../../lib/const';

// import { limpaCarrinho } from '../../store/modules/cart/actions';

// import TitleBar from '../../components/TitleBar';
// import { FormWrapper, Form } from '../../components/Form';
// import Input from '../../components/Form/Input';
// import TextArea from '../../components/Form/Input/TextArea';

// import TableHeader from '../../components/Table/TableHeader';
// import { Table, RowMaster } from '../../components/Table';

// import ActionMenu from '../../components/ActionMenu';
// import MaskedInput from '../../components/Form/Input/MaskedInput';
// import { enviaEmailSolicitacao } from '../../lib/paramUtils';

// /** validação dos campos */
// const schemaPara = Yup.object().shape({
//   paraNome: Yup.string().required('O campo "Para" deve ser preenchido'),
//   paraEmail: Yup.string()
//     .email('E-mail inválido')
//     .required('O campo "E-mail" deve ser preenchido'),
// });

// const schema = Yup.object().shape({
//   deNome: Yup.string().required('O campo "Nome" deve ser preenchido'),
//   deEmail: Yup.string()
//     .email('E-mail inválido')
//     .required('O campo "E-mail" deve ser preenchido'),
//   deTelefone: Yup.number()
//     .typeError('O campo "Telefone" deve ser preenchido')
//     .required('O campo "Telefone" deve ser preenchido'),
//   deEmpresa: Yup.string().required('O campo "Empresa" deve ser preenchido'),
//   mensagem: Yup.string().nullable(),
//   deCPF: Yup.string().when({
//     is: () => !enviaEmailSolicitacao(),
//     then: Yup.string()
//       .min(11, 'O CPF deve ter 11 digitos')
//       .max(11, 'O CPF deve ter 11 digitos')
//       .required('O campo "CPF" deve ser preenchido.'),
//     otherwise: Yup.string(),
//   }),
//   deCNPJ: Yup.string().when({
//     is: () => !enviaEmailSolicitacao(),
//     then: Yup.string()
//       .min(14, 'O CNPJ deve ter 14 digitos')
//       .max(14, 'O CNPJ deve ter 14 digitos')
//       .required('O campo "CNPJ" deve ser preenchido'),
//     otherwise: Yup.string(),
//   }),
// });

// export const emailTipo = {
//   EMAIL_CARRINHO: 0,
//   EMAIL_CHECKOUT: 1,
//   EMAIL_PAGINA: 2,
// };

// function Email() {
//   const formRef = useRef(null);
//   const formRefAdicionarDestinatario = useRef(null);

//   const location = useLocation();
//   const { tipo, paraEmpresa, data: extras } = location.state;

//   const profile = useSelector((state) => state.user.profile || {});
//   const { action } = useSelector((state) => state.auth || {});

//   const dispatch = useDispatch();

//   const [emails, setEmails] = useState([]);

//   useEffect(() => {
//     const { empresa } = profile;

//     /** atribui automaticamente a empresa como destinatário único */
//     if (empresa && empresa.email && paraEmpresa) {
//       setEmails([{ paraNome: empresa.descricao, paraEmail: empresa.email }]);
//     }
//   }, [profile, paraEmpresa]);

//   const handleConfirmar = useCallback(async () => {
//     try {
//       const data = formRef.current.getData();

//       await schema.validate(data, {
//         abortEarly: false,
//       });

//       const {
//         deEmail,
//         deNome,
//         deTelefone,
//         deEmpresa,
//         mensagem,
//         deCPF,
//         deCNPJ,
//       } = data;

//       /** verifica foi adicionado pelo meno um destinatário */
//       if (emails.length === 0) {
//         throw new Error('É necessário adicionar pelo menos um destinatário');
//       }

//       /** formata o remetente */
//       const remetente = `{"deEmail":"${deEmail}","deNome":"${deNome}", "deCPF": "${deCPF}", "deTelefone":"${deTelefone}","deEmpresa":"${deEmpresa}", "deCNPJ":"${deCNPJ}"}`;

//       /** formata os destinatários */
//       const destinatario = emails
//         .map(
//           ({ paraEmail, paraNome }) =>
//             `{"paraEmail":"${paraEmail}","paraNome":"${paraNome}"}`
//         )
//         .join(';');

//       /** pega as informações extras */
//       const { idSolicitacao = null, attachment = null, filename = null } =
//         extras || {};

//       /** formulário de dados */
//       const formData = new FormData();
//       formData.append('file', attachment);
//       formData.append('remetente', remetente);
//       formData.append('destinatario', destinatario);
//       formData.append('mensagem', mensagem);

//       switch (tipo) {
//         case emailTipo.EMAIL_CARRINHO:
//           await api.post('/email/carrinho', formData);
//           break;
//         case emailTipo.EMAIL_CHECKOUT:
//           /** informações adicionais da solicitação */
//           formData.append('idSolicitacao', idSolicitacao);

//           await api.post('/email/solicitacao', formData);
//           break;
//         case emailTipo.EMAIL_PAGINA:
//           await api.post('/email/pagina-catalogo', {
//             remetente,
//             destinatario,
//             mensagem,
//             filename,
//           });
//           break;
//         default:
//           break;
//       }

//       if (action === opTipoAcao.INTEGRACAO_TOKEN) {
//         /** limpa itens do carrinho */
//         dispatch(limpaCarrinho());
//       }

//       toast.success('E-mail enviado com sucesso!');

//       history.goBack();
//     } catch (err) {
//       AppError(err, formRef);
//     }
//   }, [emails, tipo, extras, action, dispatch]);

//   const handleAdicionar = useCallback(async () => {
//     try {
//       const data = formRefAdicionarDestinatario.current.getData();

//       await schemaPara.validate(data, {
//         abortEarly: false,
//       });

//       const { paraNome, paraEmail } = data;

//       setEmails((state) => [
//         ...state,
//         {
//           paraNome,
//           paraEmail,
//         },
//       ]);

//       /** limpa campos do destinatário */
//       formRefAdicionarDestinatario.current.clearField('paraNome');
//       formRefAdicionarDestinatario.current.clearField('paraEmail');
//     } catch (err) {
//       AppError(err, formRef);
//       toast.error('Verificar destinatário. Não foi possível adicionar o email');
//     }
//   }, []);

//   const handleRemover = useCallback(
//     (index) => {
//       /** Excluí destinatário */
//       emails.splice(index, 1);

//       setEmails([...emails]);
//     },
//     [emails]
//   );

//   const aplicarMascara = (valor, mascara) => {
//     const valorSemMascara = valor.replace(/\D/g, '');

//     let index = 0;

//     const valorComMacara = mascara.replace(/0/g, () => {
//       const digit = valorSemMascara[index] || '';
//       index += 1;
//       return digit;
//     });

//     return valorComMacara;
//   };

//   useEffect(() => {
//     let isMounted = true;

//     async function fetchEmail() {
//       const { empresa } = profile;
//       const { emailData = null } = paraEmpresa || {};

//       if (enviaEmailSolicitacao() && emailData !== null && formRef.current) {
//         try {
//           const { data: usuario } = await api.get(
//             `/usuario/${emailData.userId}`
//           );
//           if (!isMounted) return;

//           setEmails([
//             { paraNome: empresa.descricao, paraEmail: empresa.email },
//             {
//               paraNome: 'Responsável',
//               paraEmail: usuario.emailResponsavel,
//             },
//           ]);

//           const form = formRef.current.getData();

//           const telefone = usuario.complemento.find(
//             (i) => i.chave === 'cpTelefone'
//           );
//           const cidade = usuario.complemento.find(
//             (i) => i.chave === 'cpCidade'
//           );
//           const estado = usuario.complemento.find(
//             (i) => i.chave === 'cpEstado'
//           );
//           const regiao = usuario.complemento.find(
//             (i) => i.chave === 'cpRegiao'
//           );
//           const empresaComp = usuario.complemento.find(
//             (i) => i.chave === 'cpEmpresa'
//           );

//           form.deNome = usuario.nome;
//           form.deEmail = emailData.email;
//           form.deEmpresa = empresaComp.valor;
//           form.deTelefone = telefone.valor;
//           form.deCPF =
//             Number(usuario.tipoDocumento) === 0
//               ? aplicarMascara(
//                   usuario.documento,
//                   opMascaraDocumento[opTipoDocumento.CPF]
//                 )
//               : '';
//           form.deCNPJ = Number(usuario.tipoDocumento === 1)
//             ? aplicarMascara(
//                 usuario.documento,
//                 opMascaraDocumento[opTipoDocumento.CNPJ]
//               )
//             : '';
//           form.deCidade = cidade.valor;
//           form.deEstado = estado.valor;
//           form.deRegiao = regiao.valor;

//           formRef.current.setData(form);
//         } catch (error) {
//           console.error('Erro ao buscar email:', error);
//         }
//       }
//     }

//     if (enviaEmailSolicitacao()) {
//       fetchEmail();
//     }

//     return () => {
//       isMounted = false;
//     };
//   }, [profile, paraEmpresa]);

//   return (
//     <>
//       <TitleBar back={!!location.background} title="Envio de e-mail" />

//       <FormWrapper>
//         <Form
//           id="formEnviarEmail"
//           ref={formRef}
//           autoComplete="off"
//           onSubmit={handleConfirmar}
//         >
//           <Form.Row>
//             <Input
//               id="deNome"
//               name="deNome"
//               placeholder="Seu nome"
//               disabled={enviaEmailSolicitacao()}
//               type="text"
//             />
//             <Input
//               id="deTelefone"
//               name="deTelefone"
//               placeholder="Seu telefone"
//               disabled={enviaEmailSolicitacao()}
//               type="number"
//             />
//           </Form.Row>
//           <Form.Row>
//             {enviaEmailSolicitacao() ? (
//               <Input
//                 id="deCPF"
//                 name="deCPF"
//                 placeholder="Seu CPF"
//                 disabled={enviaEmailSolicitacao()}
//                 type="text"
//               />
//             ) : (
//               <MaskedInput
//                 id="deCPF"
//                 name="deCPF"
//                 placeholder="Seu CPF"
//                 width={430}
//                 mask={opMascaraDocumento[opTipoDocumento.CPF] || ''}
//                 type="text"
//               />
//             )}
//           </Form.Row>
//           <Form.Row>
//             <Input
//               id="deEmail"
//               name="deEmail"
//               placeholder="Seu e-mail"
//               disabled={enviaEmailSolicitacao()}
//               type="text"
//             />
//           </Form.Row>
//           <Form.Row>
//             <Input
//               id="deEmpresa"
//               name="deEmpresa"
//               placeholder="Sua empresa"
//               disabled={enviaEmailSolicitacao()}
//               type="text"
//             />
//           </Form.Row>
//           <Form.Row>
//             {enviaEmailSolicitacao() ? (
//               <Input
//                 id="deCNPJ"
//                 name="deCNPJ"
//                 placeholder="CNPJ da sua empresa"
//                 disabled={enviaEmailSolicitacao()}
//                 type="text"
//               />
//             ) : (
//               <MaskedInput
//                 id="deCNPJ"
//                 name="deCNPJ"
//                 placeholder="CNPJ da sua empresa"
//                 width={430}
//                 mask={opMascaraDocumento[opTipoDocumento.CNPJ] || ''}
//                 type="text"
//               />
//             )}
//           </Form.Row>
//           {enviaEmailSolicitacao() && (
//             <Form.Row>
//               <Input
//                 id="deCidade"
//                 name="deCidade"
//                 placeholder="Sua cidade"
//                 disabled={enviaEmailSolicitacao()}
//                 type="text"
//               />
//               <Input
//                 id="deEstado"
//                 name="deEstado"
//                 placeholder="Seu estado"
//                 disabled={enviaEmailSolicitacao()}
//                 type="text"
//               />
//               <Input
//                 id="deRegiao"
//                 name="deRegiao"
//                 placeholder="Sua região"
//                 disabled={enviaEmailSolicitacao()}
//                 type="text"
//               />
//             </Form.Row>
//           )}
//           <Form.Row>
//             <TextArea
//               id="mensagem"
//               name="mensagem"
//               placeholder="Sua mensagem"
//               rows="8"
//             />
//           </Form.Row>
//         </Form>

//         {(!paraEmpresa || enviaEmailSolicitacao()) && (
//           <>
//             <Form
//               id="formAdicionarDestinatario"
//               autoComplete="off"
//               ref={formRefAdicionarDestinatario}
//               onSubmit={handleAdicionar}
//             >
//               <h3>Destinatário</h3>
//               <Form.Row>
//                 <Input
//                   id="paraNome"
//                   name="paraNome"
//                   placeholder="Para:"
//                   type="text"
//                 />

//                 <Input
//                   id="paraEmail"
//                   name="paraEmail"
//                   placeholder="E-mail:"
//                   type="text"
//                 />
//               </Form.Row>
//             </Form>
//             <Form.Footer withStart>
//               <button
//                 id="btn-submit"
//                 type="submit"
//                 form="formAdicionarDestinatario"
//               >
//                 Adicionar
//               </button>
//             </Form.Footer>

//             <Form.Row>
//               <Form.Column>
//                 <h3>Lista de Destinatários:</h3>
//                 <Table>
//                   <TableHeader
//                     withPadding
//                     titles={[
//                       { fieldname: 'para', title: 'Para' },
//                       { fieldname: 'email', title: 'E-mail' },
//                       { fieldname: null, title: null },
//                     ]}
//                     cbSort={() => {}}
//                   />
//                   <tbody>
//                     {emails.map((email, index) => (
//                       <RowMaster key={index}>
//                         <td>{email.paraNome}</td>
//                         <td>{email.paraEmail}</td>
//                         <td>
//                           <ActionMenu
//                             data={email}
//                             onLineRemove={() => handleRemover(index)}
//                             onRemove={() => handleRemover(index)}
//                           />
//                         </td>
//                       </RowMaster>
//                     ))}
//                   </tbody>
//                 </Table>
//               </Form.Column>
//             </Form.Row>
//           </>
//         )}

//         <Form.Separate withFlex />
//         <Form.Footer>
//           <button
//             id="btn-cancel"
//             type="button"
//             onClick={() => history.goBack()}
//           >
//             Cancelar
//           </button>
//           <button id="btn-submit" type="submit" form="formEnviarEmail">
//             Enviar
//           </button>
//         </Form.Footer>
//       </FormWrapper>
//     </>
//   );
// }

// export { Email };

import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import { AppError } from '../../errors/AppError';

import api from '../../services/api';
import history from '../../services/history';

import {
  opTipoAcao,
  opTipoDocumento,
  opMascaraDocumento,
} from '../../lib/const';

import { limpaCarrinho } from '../../store/modules/cart/actions';

import TitleBar from '../../components/TitleBar';
import { FormWrapper, Form } from '../../components/Form';
import Input from '../../components/Form/Input';
import TextArea from '../../components/Form/Input/TextArea';

import TableHeader from '../../components/Table/TableHeader';
import { Table, RowMaster } from '../../components/Table';

import ActionMenu from '../../components/ActionMenu';
import MaskedInput from '../../components/Form/Input/MaskedInput';
import { enviaEmailSolicitacao } from '../../lib/paramUtils';
import {
  ADD,
  CANCEL,
  EMAIL,
  EMAIL_SENDING,
  opIdiomaCatalogo,
  RECIPIENT,
  RECIPIENT_LIST,
  REQUESTER,
  SEND,
  TO,
  YOUR_CITY,
  YOUR_COMPANY,
  YOUR_COMPANY_DOCUMENT,
  YOUR_EMAIL,
  YOUR_MESSAGE,
  YOUR_NAME,
  YOUR_PERSONAL_DOCUMENT,
  YOUR_PHONE,
  YOUR_REGION,
  YOUR_STATE,
} from '../../lib/idiomaAppOptions';

/** validação dos campos */
const schemaPara = Yup.object().shape({
  paraNome: Yup.string().required('O campo "Para" deve ser preenchido'),
  paraEmail: Yup.string()
    .email('E-mail inválido')
    .required('O campo "E-mail" deve ser preenchido'),
});

const schema = Yup.object().shape({
  deNome: Yup.string().required('O campo "Nome" deve ser preenchido'),
  deEmail: Yup.string()
    .email('E-mail inválido')
    .required('O campo "E-mail" deve ser preenchido'),
  deTelefone: Yup.number()
    .typeError('O campo "Telefone" deve ser preenchido')
    .required('O campo "Telefone" deve ser preenchido'),
  deEmpresa: Yup.string().required('O campo "Empresa" deve ser preenchido'),
  mensagem: Yup.string().nullable(),
  deCPF: Yup.string().when({
    is: () => !enviaEmailSolicitacao(),
    then: Yup.string()
      .min(11, 'O CPF deve ter 11 digitos')
      .max(11, 'O CPF deve ter 11 digitos')
      .required('O campo "CPF" deve ser preenchido.'),
    otherwise: Yup.string(),
  }),
  deCNPJ: Yup.string().when({
    is: () => !enviaEmailSolicitacao(),
    then: Yup.string()
      .min(14, 'O CNPJ deve ter 14 digitos')
      .max(14, 'O CNPJ deve ter 14 digitos')
      .required('O campo "CNPJ" deve ser preenchido'),
    otherwise: Yup.string(),
  }),
});

export const emailTipo = {
  EMAIL_CARRINHO: 0,
  EMAIL_CHECKOUT: 1,
  EMAIL_PAGINA: 2,
};

function Email() {
  const formRef = useRef(null);
  const formRefAdicionarDestinatario = useRef(null);

  const location = useLocation();
  const { tipo, paraEmpresa, data: extras } = location.state;

  const profile = useSelector((state) => state.user.profile || {});
  const { action } = useSelector((state) => state.auth || {});

  /** e-mail do deep-link SSO (destinatário do orçamento/solicitação) */
  const ssoQuoteEmail = useSelector(
    (state) => (state.param.sso && state.param.sso.quoteEmail) || null
  );

  /** idioma do catálogo escolhido pelo usuário (null = padrão) */
  const idiomaCatalogo = useSelector(
    (state) => state.param.idiomaCatalogo || null
  );

  const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

  const dispatch = useDispatch();

  const [emails, setEmails] = useState([]);

  useEffect(() => {
    const { empresa } = profile;

    /**
     * Deep-link SSO: o e-mail recebido no acesso é o destinatário do orçamento.
     * Tem prioridade sobre o e-mail da empresa.
     */
    if (ssoQuoteEmail) {
      setEmails([{ paraNome: REQUESTER[idioma], paraEmail: ssoQuoteEmail }]);
      return;
    }

    /** atribui automaticamente a empresa como destinatário único */
    if (empresa && empresa.email && paraEmpresa) {
      setEmails([{ paraNome: empresa.descricao, paraEmail: empresa.email }]);
    }
  }, [profile, paraEmpresa, ssoQuoteEmail]);

  const handleConfirmar = useCallback(async () => {
    try {
      const data = formRef.current.getData();

      await schema.validate(data, {
        abortEarly: false,
      });

      const {
        deEmail,
        deNome,
        deTelefone,
        deEmpresa,
        mensagem,
        deCPF,
        deCNPJ,
      } = data;

      /** verifica foi adicionado pelo meno um destinatário */
      if (emails.length === 0) {
        throw new Error('É necessário adicionar pelo menos um destinatário');
      }

      /** formata o remetente */
      const remetente = `{"deEmail":"${deEmail}","deNome":"${deNome}", "deCPF": "${deCPF}", "deTelefone":"${deTelefone}","deEmpresa":"${deEmpresa}", "deCNPJ":"${deCNPJ}"}`;

      /** formata os destinatários */
      const destinatario = emails
        .map(
          ({ paraEmail, paraNome }) =>
            `{"paraEmail":"${paraEmail}","paraNome":"${paraNome}"}`
        )
        .join(';');

      /** pega as informações extras */
      const { idSolicitacao = null, attachment = null, filename = null } =
        extras || {};

      /** formulário de dados */
      const formData = new FormData();
      formData.append('file', attachment);
      formData.append('remetente', remetente);
      formData.append('destinatario', destinatario);
      formData.append('mensagem', mensagem);

      switch (tipo) {
        case emailTipo.EMAIL_CARRINHO:
          await api.post('/email/carrinho', formData);
          break;
        case emailTipo.EMAIL_CHECKOUT:
          /** informações adicionais da solicitação */
          formData.append('idSolicitacao', idSolicitacao);

          await api.post('/email/solicitacao', formData);
          break;
        case emailTipo.EMAIL_PAGINA:
          await api.post('/email/pagina-catalogo', {
            remetente,
            destinatario,
            mensagem,
            filename,
          });
          break;
        default:
          break;
      }

      if (action === opTipoAcao.INTEGRACAO_TOKEN) {
        /** limpa itens do carrinho */
        dispatch(limpaCarrinho());
      }

      toast.success('E-mail enviado com sucesso!');

      history.goBack();
    } catch (err) {
      AppError(err, formRef);
    }
  }, [emails, tipo, extras, action, dispatch]);

  const handleAdicionar = useCallback(async () => {
    try {
      const data = formRefAdicionarDestinatario.current.getData();

      await schemaPara.validate(data, {
        abortEarly: false,
      });

      const { paraNome, paraEmail } = data;

      setEmails((state) => [
        ...state,
        {
          paraNome,
          paraEmail,
        },
      ]);

      /** limpa campos do destinatário */
      formRefAdicionarDestinatario.current.clearField('paraNome');
      formRefAdicionarDestinatario.current.clearField('paraEmail');
    } catch (err) {
      AppError(err, formRef);
      toast.error('Verificar destinatário. Não foi possível adicionar o email');
    }
  }, []);

  const handleRemover = useCallback(
    (index) => {
      /** Excluí destinatário */
      emails.splice(index, 1);

      setEmails([...emails]);
    },
    [emails]
  );

  const aplicarMascara = (valor, mascara) => {
    const valorSemMascara = valor.replace(/\D/g, '');

    let index = 0;

    const valorComMacara = mascara.replace(/0/g, () => {
      const digit = valorSemMascara[index] || '';
      index += 1;
      return digit;
    });

    return valorComMacara;
  };

  useEffect(() => {
    let isMounted = true;

    async function fetchEmail() {
      const { empresa } = profile;
      const { emailData = null } = paraEmpresa || {};

      if (enviaEmailSolicitacao() && emailData !== null && formRef.current) {
        try {
          const { data: usuario } = await api.get(
            `/usuario/${emailData.userId}`
          );
          if (!isMounted) return;

          setEmails([
            { paraNome: empresa.descricao, paraEmail: empresa.email },
            {
              paraNome: 'Responsável',
              paraEmail: usuario.emailResponsavel,
            },
          ]);

          const form = formRef.current.getData();

          const telefone = usuario.complemento.find(
            (i) => i.chave === 'cpTelefone'
          );
          const cidade = usuario.complemento.find(
            (i) => i.chave === 'cpCidade'
          );
          const estado = usuario.complemento.find(
            (i) => i.chave === 'cpEstado'
          );
          const regiao = usuario.complemento.find(
            (i) => i.chave === 'cpRegiao'
          );
          const empresaComp = usuario.complemento.find(
            (i) => i.chave === 'cpEmpresa'
          );

          form.deNome = usuario.nome;
          form.deEmail = emailData.email;
          form.deEmpresa = empresaComp.valor;
          form.deTelefone = telefone.valor;
          form.deCPF =
            Number(usuario.tipoDocumento) === 0
              ? aplicarMascara(
                  usuario.documento,
                  opMascaraDocumento[opTipoDocumento.CPF]
                )
              : '';
          form.deCNPJ = Number(usuario.tipoDocumento === 1)
            ? aplicarMascara(
                usuario.documento,
                opMascaraDocumento[opTipoDocumento.CNPJ]
              )
            : '';
          form.deCidade = cidade.valor;
          form.deEstado = estado.valor;
          form.deRegiao = regiao.valor;

          formRef.current.setData(form);
        } catch (error) {
          console.error('Erro ao buscar email:', error);
        }
      }
    }

    if (enviaEmailSolicitacao()) {
      fetchEmail();
    }

    return () => {
      isMounted = false;
    };
  }, [profile, paraEmpresa]);

  return (
    <>
      <TitleBar back={!!location.background} title={EMAIL_SENDING[idioma]} />

      <FormWrapper>
        <Form
          id="formEnviarEmail"
          ref={formRef}
          autoComplete="off"
          onSubmit={handleConfirmar}
        >
          <Form.Row>
            <Input
              id="deNome"
              name="deNome"
              placeholder={YOUR_NAME[idioma]}
              disabled={enviaEmailSolicitacao()}
              type="text"
            />
            <Input
              id="deTelefone"
              name="deTelefone"
              placeholder={YOUR_PHONE[idioma]}
              disabled={enviaEmailSolicitacao()}
              type="number"
            />
          </Form.Row>
          <Form.Row>
            {enviaEmailSolicitacao() ? (
              <Input
                id="deCPF"
                name="deCPF"
                placeholder={YOUR_PERSONAL_DOCUMENT[idioma]}
                disabled={enviaEmailSolicitacao()}
                type="text"
              />
            ) : (
              <MaskedInput
                id="deCPF"
                name="deCPF"
                placeholder={YOUR_PERSONAL_DOCUMENT[idioma]}
                width={430}
                mask={opMascaraDocumento[opTipoDocumento.CPF] || ''}
                type="text"
              />
            )}
          </Form.Row>
          <Form.Row>
            <Input
              id="deEmail"
              name="deEmail"
              placeholder={YOUR_EMAIL[idioma]}
              disabled={enviaEmailSolicitacao()}
              type="text"
            />
          </Form.Row>
          <Form.Row>
            <Input
              id="deEmpresa"
              name="deEmpresa"
              placeholder={YOUR_COMPANY[idioma]}
              disabled={enviaEmailSolicitacao()}
              type="text"
            />
          </Form.Row>
          <Form.Row>
            {enviaEmailSolicitacao() ? (
              <Input
                id="deCNPJ"
                name="deCNPJ"
                placeholder={YOUR_COMPANY_DOCUMENT[idioma]}
                disabled={enviaEmailSolicitacao()}
                type="text"
              />
            ) : (
              <MaskedInput
                id="deCNPJ"
                name="deCNPJ"
                placeholder={YOUR_COMPANY_DOCUMENT[idioma]}
                width={430}
                mask={opMascaraDocumento[opTipoDocumento.CNPJ] || ''}
                type="text"
              />
            )}
          </Form.Row>
          {enviaEmailSolicitacao() && (
            <Form.Row>
              <Input
                id="deCidade"
                name="deCidade"
                placeholder={YOUR_CITY[idioma]}
                disabled={enviaEmailSolicitacao()}
                type="text"
              />
              <Input
                id="deEstado"
                name="deEstado"
                placeholder={YOUR_STATE[idioma]}
                disabled={enviaEmailSolicitacao()}
                type="text"
              />
              <Input
                id="deRegiao"
                name="deRegiao"
                placeholder={YOUR_REGION[idioma]}
                disabled={enviaEmailSolicitacao()}
                type="text"
              />
            </Form.Row>
          )}
          <Form.Row>
            <TextArea
              id="mensagem"
              name="mensagem"
              placeholder={YOUR_MESSAGE[idioma]}
              rows="8"
            />
          </Form.Row>
        </Form>

        {(!paraEmpresa || enviaEmailSolicitacao()) && (
          <>
            <Form
              id="formAdicionarDestinatario"
              autoComplete="off"
              ref={formRefAdicionarDestinatario}
              onSubmit={handleAdicionar}
            >
              <h3>{RECIPIENT[idioma]}</h3>
              <Form.Row>
                <Input
                  id="paraNome"
                  name="paraNome"
                  placeholder={`${TO[idioma]}:`}
                  type="text"
                />

                <Input
                  id="paraEmail"
                  name="paraEmail"
                  placeholder={`${EMAIL[idioma]}:`}
                  type="text"
                />
              </Form.Row>
            </Form>
            <Form.Footer withStart>
              <button
                id="btn-submit"
                type="submit"
                form="formAdicionarDestinatario"
              >
                {ADD[idioma]}
              </button>
            </Form.Footer>

            <Form.Row>
              <Form.Column>
                <h3>{`${RECIPIENT_LIST[idioma]}:`}</h3>
                <Table>
                  <TableHeader
                    withPadding
                    titles={[
                      { fieldname: 'para', title: TO[idioma] },
                      { fieldname: 'email', title: EMAIL[idioma] },
                      { fieldname: null, title: null },
                    ]}
                    cbSort={() => {}}
                  />
                  <tbody>
                    {emails.map((email, index) => (
                      <RowMaster key={index}>
                        <td>{email.paraNome}</td>
                        <td>{email.paraEmail}</td>
                        <td>
                          <ActionMenu
                            data={email}
                            onLineRemove={() => handleRemover(index)}
                            onRemove={() => handleRemover(index)}
                          />
                        </td>
                      </RowMaster>
                    ))}
                  </tbody>
                </Table>
              </Form.Column>
            </Form.Row>
          </>
        )}

        <Form.Separate withFlex />
        <Form.Footer>
          <button
            id="btn-cancel"
            type="button"
            onClick={() => history.goBack()}
          >
            {CANCEL[idioma]}
          </button>
          <button id="btn-submit" type="submit" form="formEnviarEmail">
            {SEND[idioma]}
          </button>
        </Form.Footer>
      </FormWrapper>
    </>
  );
}

export { Email };
